import React, { Component } from 'react';
import { number, object, func, array, string, bool } from 'prop-types';
import { connect } from 'react-redux';
import FacetPanel from 'ps-components/FacetPanel/FacetPanel';
import SearchBarMP from 'ps-components/SearchBarMP/SearchBarMP';
import Dropdown from 'ps-components/Dropdown/Dropdown';
import Pagination from 'ps-components/Pagination/Pagination';
import getHiddenFacets from 'ps-components/FacetPanel/getHiddenFacets';
import { setSelectedBenchmarkYear } from '../../CompensationSummary/CompensationSummaryActions';
import { jobsInRangeSearchActions } from './facets/JobsInRange';
import { parseNumCheckNull, parseFloatCheckNull, applyRounding } from 'ps-components/lib/formatters';
import { areAllFacetsChecked } from '../../../lib/facetHelpers';
import { withRouter } from 'react-router';
import './JobsInGrade.scss';
import ListPanel from 'ps-components/AdvancedTable/ListPanel/ListPanel';
import AdvancedCell from 'ps-components/AdvancedTable/AdvancedCell';

const propTypes = {};

const defaultProps = {};
const MKT_BASE_FIFTY = 'Market base at 50th',
  RANGE_PEN = 'Proposed Range Penetration Average',
  COMPA_RATIO = 'Proposed Compa-Ratio Average',
  MID_MARKET = 'Proposed Mid to Market Base 50th';

class JobsInGrade extends Component {
  static propTypes = {
    minimum: number,
    midpoint: number,
    maximum: number,
    jobsInRangeSearch: object,
    jobsInRangeSearchItems: array,
    facetItemClick: func,
    facetReset: func,
    searchInputSearch: func,
    handleReset: func,
    getJobData: func,
    pageList: func,
    searchResultsCount: number,
    setSearchText: func,
    searchText: string,
    useJobCodeKey: bool,
    jobCodeKeyText: string,
    history: object,
    benchmarkYear: number,
    setSelectedBenchmarkYear: func,
    basis: string
  };

  constructor(props) {
    super(props);
    this.state = { activeSelect: MKT_BASE_FIFTY };
    this.handleDropdownSwitch = this.handleDropdownSwitch.bind(this);
    this.getDataKey = this.getDataKey.bind(this);
    this.getJobDataCall = this.getJobDataCall.bind(this);
    this.getText = this.getText.bind(this);
    this.searchBarSubmit = this.searchBarSubmit.bind(this);
    this.openCompSummary = this.openCompSummary.bind(this);
    this.getDataRow = this.getDataRow.bind(this);
    this.scrollRef = React.createRef();
  }

  componentDidMount() {
    this.getJobDataCall();
  }

  componentDidUpdate(prevProps) {
    if (this.props.jobsInRangeSearchItems !== prevProps.jobsInRangeSearchItems) this.getJobDataCall();
  }

  getJobDataCall() {
    const { getJobData, minimum, midpoint, maximum, basis } = this.props;
    getJobData(
      this.props.jobsInRangeSearch.items.map(job => {
        return {
          jobCode: job.org_job_code,
          jobCodeKey: job.org_job_code_key
        };
      }),
      basis,
      minimum,
      midpoint,
      maximum
    );
  }

  pageJobs = (first, newAfter) => {
    this.props.pageList(first, newAfter);
  };

  handleDropdownSwitch(item) {
    this.getJobDataCall();
    this.setState({ activeSelect: item });
  }

  openCompSummary(job) {
    const { setSelectedBenchmarkYear, benchmarkYear } = this.props;
    const jobFormat = {
      id: job.original.org_job_id,
      title: job.original.org_job_title,
      code: job.original.org_job_code,
      codeKey: job.original.org_job_code_key,
      __typename: 'OrgJob',
      reason: 'test Reason'
    };

    setSelectedBenchmarkYear(benchmarkYear);

    this.props.history.push(
      `${this.props.location.pathname}${this.props.location.search}#structure-model-analytics/jobs/${jobFormat.id}/compensation-summary-report`,
      {
        modal: true,
        modalType: 'COMPENSATION_SUMMARY_REPORT',
        modalProps: { className: 'comp-sum__modal', orgJob: jobFormat },
        component: 'COMPENSATION_SUMMARY_REPORT'
      }
    );
  }

  getDataKey(item) {
    switch (item) {
      case MKT_BASE_FIFTY:
        return 'base_50th';
      case RANGE_PEN:
        return 'range_pen';
      case COMPA_RATIO:
        return 'comp_ratio';
      case MID_MARKET:
        return 'mid_mkt';
    }
  }

  getDataRow(el, idx) {
    const { useJobCodeKey, jobCodeKeyText } = this.props;
    return (
      <React.Fragment>
        <AdvancedCell getCellProps={el.cells[0].getCellProps}>
          <h4 className="sma-jobs-grade_list__title">{el.original.org_job_title}</h4>
          <div className="advanced-list-panel__sub-label">
            <span className="label">Job Code</span>
            <span className="text">{el.original.org_job_code}</span>
            {useJobCodeKey && (
              <React.Fragment>
                <span className="label">{jobCodeKeyText}</span>
                <span className="text">{el.original.org_job_code_key}</span>
              </React.Fragment>
            )}
          </div>
        </AdvancedCell>
        <AdvancedCell getCellProps={el.cells[1].getCellProps} className="right-align">
          <h4 className="sma-jobs-grade_list__value-pay">{el.original[this.getDataKey(this.state.activeSelect)]}</h4>
        </AdvancedCell>
      </React.Fragment>
    );
  }

  getText(event) {
    const { setSearchText } = this.props;

    event.persist();
    const value = event.target.value;
    setSearchText(value);
  }

  searchBarSubmit(event) {
    this.props.searchInputSearch(event.target.value);
  }

  getRoundedPercent(value) {
    return value ? applyRounding(value * 100, 'percent') : '-';
  }

  render() {
    const {
      jobsInRangeSearch,
      jobsInRangeSearchItems,
      facetItemClick,
      facetReset,
      searchInputSearch,
      handleReset,
      searchText,
      useJobCodeKey,
      jobCodeKeyText
    } = this.props;

    const showResetButton =
      areAllFacetsChecked(jobsInRangeSearch.facets, jobsInRangeSearch.facetSelection) ||
      (jobsInRangeSearch.lastQueryParams && jobsInRangeSearch.lastQueryParams.es_query !== '');
    let columns = [
      { Header: 'Job Title', accessor: 'org_job_title', width: 300 },
      {
        Header: this.state.activeSelect,
        accessor: this.getDataKey(this.state.activeSelect),
        width: 200,
        rightAlign: true
      }
    ];

    let dropdownItems = [MKT_BASE_FIFTY, RANGE_PEN, COMPA_RATIO, MID_MARKET];

    return (
      <div className="sma-jobs-grade_contents__main">
        <div className="org__job-facet__panel-container">
          <FacetPanel
            className="sma-jobs-grade_facet org__job-facets"
            facetItemClick={facetItemClick}
            facetReset={facetReset}
            facets={jobsInRangeSearch.facets}
            hiddenFacets={getHiddenFacets('jobsInGrade', useJobCodeKey)}
            facetSelection={jobsInRangeSearch.facetSelection}
            isLoaded={jobsInRangeSearch.loaded}
            lastFacetFilteredID={jobsInRangeSearch.lastFacetFilteredID}
            limit={5}
            resetSearch={handleReset}
            showFacetSectionSearch={true}
            showResetButton={showResetButton}
            showZeros={jobsInRangeSearch.showZeros}
          />
        </div>
        <div className="sma-jobs-grade_jobs-panel" ref={this.scrollRef} data-test-id="sma-jobs-grade_jobs-panel">
          <div className="sma-jobs-grade__dropdown-select">
            Show
            <Dropdown
              className="sma-jobs-grade__dropdown-container"
              dropdownClass="sma-jobs-grade__dropdown"
              dropUp={false}
              itemOnClick={this.handleDropdownSwitch}
              text={this.state.activeSelect}
              dropdownItems={dropdownItems}
              leftBound={true}
              rightBound={false}
            />
          </div>
          <SearchBarMP
            className="sma-jobs-grade__search"
            onSearch={this.searchBarSubmit}
            defaultValue={searchText}
            onChange={this.getText}
            isDisabled={false}
          />
          <div>
            <ListPanel
              columnHeaders={columns}
              rowData={jobsInRangeSearchItems.map(job => {
                return {
                  org_job_title: job.org_job_title,
                  org_job_code_key: job.org_job_code_key,
                  org_job_code: job.org_job_code,
                  org_job_id: job.orgJobId,
                  base_50th: parseNumCheckNull(job.base_50th),
                  range_pen: this.getRoundedPercent(job.range_pen, 'percent'),
                  comp_ratio: this.getRoundedPercent(job.comp_ratio, 'percent'),
                  mid_mkt: this.getRoundedPercent(job.mid_mkt, 'percent')
                };
              })}
              getDataRow={this.getDataRow}
              className="sma-jobs-grade_list-panel"
              dataLoading={jobsInRangeSearch.loading}
              stickyHeader={true}
              onRowClick={this.openCompSummary}
              rowClassName="advanced-list-panel__row"
            />
            <Pagination
              className="sma-jobs-grade_pagination"
              containerClassName="sma-jobs-grade_pagination-container"
              pageAction={this.pageJobs}
              step={jobsInRangeSearch.limit}
              scrollEl={this.scrollRef}
              scrollTopPageChange={true}
              offset={jobsInRangeSearch.offset}
              totalCount={jobsInRangeSearch.searchResultsCount}
            />
          </div>
        </div>
      </div>
    );
  }
}

JobsInGrade.propTypes = propTypes;
JobsInGrade.defaultProps = defaultProps;

const connectState = state => {
  return {
    jobsInRangeSearch: state.structureModeling.structureModelingAnalytics.JobsInRangeReducer,
    jobsInRangeSearchItems: state.structureModeling.structureModelingAnalytics.JobsInRangeReducer.items,
    benchmarkYear: state.session.benchmarkYear
  };
};
const actions = { ...jobsInRangeSearchActions, setSelectedBenchmarkYear };
export default withRouter(connect(connectState, actions)(JobsInGrade));
